/**
 * Client ULIDs (events.md §8.4): every event a browser makes carries one, and
 * a retry resends the same id, which is what makes a double send harmless.
 *
 * Monotonic within the page, as `api/ulid.py` is within a process: the same
 * millisecond increments the random part, so ids sort in the order they were
 * made even when a beat and its dwell land in one tick.
 */
const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

let lastMs = -1;
let lastRand = 0n;

function enc(n: bigint, length: number): string {
  let out = "";
  for (let i = 0; i < length; i += 1) {
    out = ALPHABET[Number(n & 31n)] + out;
    n >>= 5n;
  }
  return out;
}

function random80(): bigint {
  const bytes = new Uint8Array(10);
  crypto.getRandomValues(bytes);
  let n = 0n;
  for (const b of bytes) n = (n << 8n) | BigInt(b);
  return n >> 1n; // headroom for increments within one millisecond
}

export function ulid(ms: number = Date.now()): string {
  if (ms === lastMs) {
    lastRand += 1n;
  } else {
    lastMs = ms;
    lastRand = random80();
  }
  return enc(BigInt(ms), 10) + enc(lastRand, 16);
}
